import { Authorization } from 'glxl-helpers';

import apiCall from '../components/apiCall';
import {
  LOGOUT_USER,
  UPDATE_USER,
} from './types';

const auth = new Authorization();

/**
 *
 * @param username
 * @param password
 * @return {Function}
 */
const login = (username, password, token = null) => dispatch => {
  if (token) {
    sessionStorage.setItem('token', `Bearer ${token}`);
    return apiCall('/user/me')
      .then((user) => {
        if (!user.role) {
          throw new Error('User has no role.');
        }
        if (!['groupmember', 'groupleader', 'classleader', 'schoolcontact'].includes(user.role)) {
          throw new Error('Deze gebruiker heeft geen toegang tot het simulatiespel.');
        }
        dispatch({ type: UPDATE_USER, payload: {
            token: token,
            loggedIn: true,
            role: user.role,
            userDetails: user,
          } });
        return true;
      })
      .catch((err) => {
        console.warn(err.message);
        auth.setAuthToken('');
        sessionStorage.removeItem('token');
        return false;
      });
  }
  if (!username || !password) return false;
  return apiCall('/user/login', {username, password}, 'POST')
    .then((access) => {
      if (!access.auth || !access.token) {
        return false;
      }
      auth.setAuthToken(access.token);
      return apiCall('/user/me')
        .then((user) => {
          if (!['groupmember', 'groupleader', 'classleader', 'schoolcontact'].includes(user.role)) {
            throw new Error('Deze gebruiker heeft geen toegang tot het simulatiespel.');
          }
          dispatch({ type: UPDATE_USER, payload: {
              token: access.token,
              loggedIn: access.auth,
              role: user.role,
              userDetails: user,
            } });
          return true;
        })
        .catch((err) => {
          console.warn(err.message);
          return false;
        });
    })
    .catch((err) => {
      console.warn(err.message);
      return false;
    });
};

/**
 *
 * @return {Function}
 */
const fetchUser = () => dispatch => {
  const token = sessionStorage.getItem('token') || auth.getAuthToken();
  if (token) {
    apiCall('/user/me')
      .then((user) => {
        dispatch({ type: UPDATE_USER,
          payload: {
            token: token.replace('Bearer ', ''),
            userDetails: user,
          }
        });

      })
      .catch((err) => {
        console.error(err.message);
      });
  }
};

/**
 *
 * @param user
 * @return {Function}
 */
const updateUser = (user) => dispatch => {
  dispatch({ type: UPDATE_USER, payload: user});
};

/**
 *
 * @return {Function}
 */
const logout = () => dispatch => {
  apiCall('/user/logout', null, 'POST')
    .then(() => {
      dispatch({ type: LOGOUT_USER });
    });
};

export default {
  fetchUser,
  updateUser,
  login,
  logout,
};



// WEBPACK FOOTER //
// ./src/actions/user.js